<template>
  <div>
    <h1 class="mb-0">Login</h1>
    <p>Enter your email address and password to log in.</p>
    <login-form
      formType="jwt"
      email="admin@demo.com"
      password="admin123"
    ></login-form>
    <p>
      Forgot password - reset
      <router-link to="/auth/send-reset-code">HERE</router-link>
      or make new
      <router-link to="/auth/register">REGISTRATION</router-link>.
    </p>
  </div>
</template>

<script>
import LoginForm from "./Forms/LoginForm";

export default {
  name: "Login",
  components: { LoginForm }
};
</script>
